export default __webpack_public_path__ + "static/media/tiktokIcon.8ed9729a.svg";